
import { Theme } from '@mui/material/styles';
import { withStyles } from 'tss-react/mui';
import DateTextEdit from '../../../../../../../Components/DateTextEdit/DateTextEdit';
import { CommonPropsAndTypes } from '../../../../../../../BaseComponents/_Types/StandardComponentProps';
import {
  DateInputType,
  getDatePlaceholder,
} from '../../../../../../../Utils/dateUtils';
import {
  IEkonomiskAnalysDates,
  IDate,
} from '../AnalysSettingsHandler/AnalysSettingsHandler';
import EDKeybind from '../../../../../../../BaseComponents/Keybinds/EDKeybind';

interface IProps {
  dateInputType?: DateInputType;
  isInterval: boolean;
  dates: IEkonomiskAnalysDates;
  onFromDateChange: (date: IDate, changeBoth?: boolean) => void;
  onToDateChange: (date: IDate) => void;
  color?: CommonPropsAndTypes.ColorType;
  dense?: boolean;
  padding?: CommonPropsAndTypes.StandardSpacingType;
  fromDateRef?: React.MutableRefObject<HTMLInputElement | null>;
  toDateRef?: React.MutableRefObject<HTMLInputElement | null>;
  updateReport?: () => void;
  toggleEditing: () => void;
  classes?: any;
}

const styles = (theme: Theme) => ({
  periodsContainer: {
    display: 'flex',
    flex: '0 1 100%',
    marginBottom: '-' + theme.spacing(2),
  },
  dateInput: {
    marginRight: theme.spacing(0.5),
    width: theme.spacing(15),
  },
  helperText: {
    color: theme.palette.grey[600],
    whiteSpace: 'initial',
  },
});

const EkonomiskAnalysPeriods: React.FunctionComponent<
  React.PropsWithChildren<IProps>
> = props => {
  const datePlaceholder = getDatePlaceholder(props.dateInputType);
  const toDateAutofocus = props.isInterval && props.dates.to.userString !== '';

  const fromDateTooltip = `Period ${
    props.isInterval ? 'start ' : ''
  } ${datePlaceholder}`;
  const toDateTooltip = `Period ${
    props.isInterval ? 'slut ' : ''
  } ${datePlaceholder}`;

  return (
    <EDKeybind
      keymap="a"
      alt
      onKeyDown={() => {
        if (props.fromDateRef?.current) {
          props.fromDateRef?.current?.blur?.();
        }

        if (props.toDateRef?.current) {
          props.toDateRef?.current?.blur?.();
        }

        props.updateReport?.();
      }}
    >
      <div className={props.classes.periodsContainer}>
        <DateTextEdit
          label={props.isInterval ? 'Period start' : 'Period'}
          date={props.dates.from}
          onBlur={props.onFromDateChange}
          placeholder={datePlaceholder}
          dateType={props.dateInputType}
          partOfInterval={props.isInterval}
          padding={props.padding}
          autoFocus={!toDateAutofocus}
          dateTextRef={props.fromDateRef}
          required
          tooltip={fromDateTooltip}
          size="small"
          allMargins="none"
          paddingRight={1}
        />
        {props.isInterval && (
          <DateTextEdit
            label="Period slut"
            date={props.dates.to}
            onBlur={date => props.onToDateChange(date)}
            className={props.classes.dateInput}
            placeholder={datePlaceholder}
            dateType={props.dateInputType}
            fixedYear={props.dates.from.year}
            partOfInterval={false}
            padding={props.padding}
            autoFocus={toDateAutofocus}
            dateTextRef={props.toDateRef}
            tooltip={toDateTooltip}
            size="small"
            allMargins="none"
          />
        )}
      </div>
    </EDKeybind>
  );
};

export default withStyles(EkonomiskAnalysPeriods, styles);
